import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import type { OpsAttentionQueueDto } from '@/types/dtos/ops/ops-platform.dto';

export const ATTENTION_QUEUE_QUERY_KEY = 'ops-attention-queue';

export function useAttentionQueueQuery() {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [ATTENTION_QUEUE_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/ops/attention-queue?limit=50`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' }) as Promise<OpsAttentionQueueDto>;
    },
    refetchInterval: 15_000,
  });
}
